module.exports = __webpack_public_path__ + "img/norberto-echevarria.76593621.jpg";